@if (showFolioMsj && numeroCarro) {
<div class="container container-cart site_b2c">
  @if (screenWidth > 450) {
  <div class="row justify-content-md-center msgStatus mb-3">
    <div class="col-12 md:col-9 xl:col-6 py-0 mx-auto mb-3">
      <div
        appDragDrop
        class="block-drop-down-file mx-auto"
        style="background: #f5f5f5"
      >
        <div class="row">
          <div class="col-4 py-0 flex justify-content-end align-items-center">
            <i
              class="fa-solid fa-circle-check"
              style="color: #118565; font-size: 48px"
            ></i>
          </div>
          <div
            class="col-8 py-0 flex justify-content-center align-items-center"
            style="color: #0063b9; font-size: 24px; font-weight: bold"
          >
            ¡GRACIAS POR TU COMPRA!
          </div>
        </div>
        <div class="row mt-2">
          <div
            class="col-12 py-0 text-justify"
            style="color: #0063b9 !important; font-size: 18px"
          >
            <p
              style="color: #0000005e; font-size: 12px; margin-bottom: 0.5rem"
            >
              <strong>#{{ numeroCarro }}</strong>
            </p>
            @if(country=='es'){
            <p>
              Estimado <strong>{{ cartData?.notification?.name }}</strong
              >, con fecha:
              <strong>
                {{ transactionDate | date : 'dd/MM/yyyy HH:mm'
                }}{{ ' ' }}</strong
              >, hemos recibido su compra y su pago de
              <strong>{{ total | number : '1.2-2' }}{{ ' ' }}</strong>
              <strong> {{ currency }}{{ ' ' }}</strong>
            </p>
            <p>
              En breve le enviaremos un correo a
              <strong>{{ ' ' + cartData?.notification?.email }}</strong> con la
              confirmación de su pedido y
              <strong>el número de Pedido (PC)</strong>.
            </p>
            } @else{ @if(country=='cl'){

            <p>
              Estimado <strong>{{ cartData?.notification?.name }}</strong
              >, hemos recibido su compra y su pago de
              <strong> {{ ' ' + total | currency }}{{ ' ' }}</strong
              >fue procesado correctamente.
            </p>
            <p>
              En breve le enviaremos un correo a
              <strong>{{ ' ' + cartData?.notification?.email }}</strong> con la
              confirmación de su pedido y
              <strong>el número de orden (OV)</strong>.
            </p>
            } @else{
            <p>
              Estimado <strong>{{ cartData?.notification?.name }}</strong
              >, con fecha: <strong> {{ transactionDate }}{{ ' ' }}</strong
              >, hemos recibido su compra y su pago de
              <strong> S/ {{ total | number : '1.2-2' }}{{ ' ' }}</strong>
              <strong> {{ currency }}{{ ' ' }}</strong>
              fue procesado correctamente con:
            </p>
            <p>
              En breve le enviaremos un correo a
              <strong>{{ ' ' + cartData?.notification?.email }}</strong> con la
              confirmación de su pedido y
              <strong>el número de Nota Venta (NV)</strong>.
            </p>

            } }
          </div>
          <!--<div class="col-12 py-0 mt-2">
                <button
                  class="btn btn-lg btn-secondary w-100 text-center"
                  style="font-size: 24px; padding-bottom: 45px"
                  >
                  N° {{ ' ' + numeroCarro }}
                </button>
              </div>-->
          <div class="col-12 py-0 mt-3 text-center">
            <h4 style="text-align: center; font-size: 22px">
              Muchas gracias por visitar {{ url }}
            </h4>
            <a
              [routerLink]="['/']"
              style="
                text-align: center;
                color: #118565;
                font-size: 14px;
                font-weight: bold;
                margin-top: 40px;
              "
            >
              Volver al inicio</a
            >
          </div>
        </div>
      </div>
    </div>
  </div>
  } @if (screenWidth <= 450) {
  <div class="row mt-3 mb-3">
    <div
      class="col-12 py-0"
      style="padding-left: 3rem; padding-right: 3rem; margin-top: 5px"
    >
      <div class="row">
        <div class="col-4 py-0 flex justify-content-end align-items-center">
          <i
            class="fa-solid fa-circle-check"
            style="color: #118565; font-size: 38px"
          ></i>
        </div>
        <div
          class="col-8 py-0 flex justify-content-center align-items-center"
          style="color: #0063b9; font-size: 20px; font-weight: bold"
        >
          ¡GRACIAS POR TU COMPRA!
        </div>
      </div>
      <div class="row mt-3">
        <div
          class="col-12 py-0 text-justify"
          style="color: #0063b9; font-size: 16px"
        >
          <p style="color: #0000005e; font-size: 12px; margin-bottom: 0.5rem">
            <strong>#{{ numeroCarro }}</strong>
          </p>
          @if(country=='cl'){
          <p>
            Estimado <strong>{{ cartData?.notification?.name }}</strong
            >, hemos recibido su compra y su pago de
            <strong> {{ ' ' + total | currency }}{{ ' ' }}</strong
            >fue procesado correctamente.
          </p>
          } @else{
          <p>
            Estimado <strong>{{ cartData?.notification?.name }}</strong
            >, con fecha: <strong> {{ transactionDate }}{{ ' ' }}</strong
            >, hemos recibido su compra y su pago de
            <strong> {{ ' S/ ' + total }}{{ ' ' }}</strong>
            <strong> {{ currency }}{{ ' ' }}</strong>
            fue procesado correctamente con:
          </p>
          <p>
            Tipo de tarjeta: <strong> {{ marca_tarjeta }}{{ ' ' }}</strong>
          </p>
          <p>
            N° de tarjeta: <strong> {{ tarjeta }}{{ ' ' }}</strong>
          </p>
          }
          <p>
            En breve le enviaremos un correo a
            <strong>{{ ' ' + cartData?.notification?.email }}</strong> con la
            confirmación de su pedido y
            <strong>el número de orden (OV)</strong>.
          </p>
        </div>
        <!--<div class="col-12 py-0 mt-2">
                <button
                  class="btn btn-lg btn-secondary w-100 text-center"
                  style="font-size: 24px"
                  >
                  N° {{ ' ' + numeroCarro }}
                </button>
              </div> -->
        <div class="col-12 py-0 mt-3 text-center">
          <h4 style="text-align: center; font-size: 22px; margin-bottom: 15px">
            Muchas gracias por visitar {{ url }}
          </h4>
          <a
            [routerLink]="['/']"
            style="
              text-align: center;
              color: #118565;
              font-size: 18px;
              font-weight: bold;
              margin-top: 20px;
            "
          >
            Ir al HOME</a
          >
        </div>
      </div>
    </div>
  </div>
  }
</div>
} @if (!showFolioMsj) {
<div class="container container-cart site_b2c">
  <div class="row justify-content-md-center msgStatus">
    <div class="col-12 md:col-9 xl:col-6 py-0 mx-auto mb-3">
      <div
        appDragDrop
        class="block-drop-down-file mx-auto flex align-items-center justify-content-center"
      >
        <input hidden type="file" #fileInput />
        @if (loadingCart) {
        <div class="cargandoCent text-center">
          <i
            class="fak fa-implementos fa-bounce"
            style="font-size: 64px; color: #0063b9"
          ></i>
          <div
            class="fa-beat-fade"
            style="
              --fa-beat-fade-opacity: 0.67;
              --fa-beat-fade-scale: 1.075;
              margin-top: 20px;
            "
          >
            @if (!verifyingPayment) {
            <span>
              Espere unos momentos, su compra es muy importante para nosotros.
            </span>
            } @if (verifyingPayment) {
            <span>
              Estamos validando su pago, por favor, espere unos momentos y no
              cierre esta ventana, su compra es muy importante para nosotros.
            </span>
            }
          </div>
        </div>
        } @if (!loadingCart) {
        <div class="block text-center">
          <i class="fas fa-check-circle mb-2"></i>
          <h1>Hemos recibido su orden de compra!</h1>
          <h1>{{ numero }}</h1>
          <p>
            Estamos validando la información para la entrega de sus productos.
            Le enviaremos una notificación con la confirmación de su compra.
          </p>
          <p>Muchas gracias por visitar {{ url }}</p>
          <a
            class="mt-3 link-primary"
            routerLink="/carro-compra/downloadpdf"
            [queryParams]="{ numero: numero }"
          >
            <i class="far fa-file-pdf"></i>
            El archivo pdf se descargará automaticamente o presione aqui para
            descargar
          </a>
          <a
            [routerLink]="['/', 'inicio']"
            class="mt-4 link-primary w-100 text-center"
          >
            <i class="fas fa-home"></i>
            Ir al home
          </a>
        </div>
        }
      </div>
    </div>
  </div>
</div>
}
